import dayjs from "dayjs";
import { Booking, EventType } from "../types";

export function groupBookingsByDate(bookings: Booking[], direction: "asc" | "desc" = "asc") {
  const sorted = [...bookings].sort((a, b) => {
    const comparison = `${a.date} ${a.time}`.localeCompare(`${b.date} ${b.time}`);
    return direction === "desc" ? -comparison : comparison;
  });
  const groups: { date: string; items: Booking[] }[] = [];

  sorted.forEach((booking) => {
    const group = groups.find((item) => item.date === booking.date);
    if (group) {
      group.items.push(booking);
    } else {
      groups.push({ date: booking.date, items: [booking] });
    }
  });

  return groups;
}

function getBookingEnd(booking: Booking, events: EventType[]) {
  const event = events.find((item) => item.id === booking.eventId);
  const durationMinutes = event?.durationMinutes || 30;
  return dayjs(`${booking.date}T${booking.time}`).add(durationMinutes, "minute");
}

export function filterBookings(bookings: Booking[], filter: "upcoming" | "past" | "range", start: string, end: string, events: EventType[] = []) {
  const now = dayjs();
  return bookings.filter((booking) => {
    if (filter === "upcoming") return getBookingEnd(booking, events).isAfter(now);
    if (filter === "past") return !getBookingEnd(booking, events).isAfter(now);
    return booking.date >= start && booking.date <= end;
  });
}

export function parseBookingNote(note = "") {
  return note.split(";").reduce(
    (acc, part) => {
      const [key, ...rest] = part.split("=");
      const value = rest.join("=").trim();
      if (key?.trim() === "quantity") acc.quantity = value;
      if (key?.trim() === "gift") acc.gift = value;
      if (key?.trim() === "sms") acc.sms = value;
      if (key?.trim() === "childGender") acc.childGender = value;
      return acc;
    },
    { quantity: "", gift: "", sms: "", childGender: "" },
  );
}
